/*
 * @Author: Latte
 * @Date: 2021-07-28 14:46:14
 * @LAstEditors: Latte
 * @LastEditTime: 2021-08-25 10:27:22
 * @FilePath: \Siui.Cloud.Medical.Web\src\utils\resCodeTest.js
 */

import {
    Message
} from "element-ui"
import {
    isVaild
} from "@/utils/validate"

export function handleRes(res, succCallback) {
    if (isVaild(res)) {
        if (res.code === 200) {
            if (isVaild(succCallback)) {
                succCallback()
            } else {
                Message({
                    message: '操作成功!',
                    type: 'success'
                })
            }

        } else {
            Message({
                message: res.message,
                type: 'error'
            })
        }
    }
}

export function handleResWithReturn(res) {
    if (isVaild(res)) {
        if (res.code === 200) {
            return true

        } else {
            Message({
                message: res.message,
                type: 'error'
            })
        }
    }
    return false
}
